module.exports = __webpack_public_path__ + "static/couple-picnic-at-lake.26533f5b.webp";